module.exports = __webpack_public_path__ + "static/img/szafa_6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_6.svg
// module id = BvBJ
// module chunks = 0